import cn from 'clsx';
import React, { FC, memo, useMemo } from 'react';

import Button from '../../Button';

import s from './GuideDescription.module.scss';
import { IGuideDescriptionProps } from './GuideDescription.types';

const GuideDescription: FC<React.PropsWithChildren<React.PropsWithChildren<IGuideDescriptionProps>>> = ({
  title,
  titleSize,
  subTitle,
  description,
  button,
  buttonContent,
  src,
  alt,
  imgChild,
  imgWidth,
  imgHeight
}) => {
  const iconComponent = useMemo(() => {
    if (!src || imgChild) return null;
    return <img src={src} alt={alt ?? '이미지'} width={imgWidth} height={imgHeight} />;
  }, [src, alt, imgChild, imgWidth, imgHeight]);

  const titleComponent = useMemo(
    () => (
      <div>
        <h3 className={titleSize === 'large' ? s['title-large'] : s['title-medium']}>{title}</h3>
      </div>
    ),
    [title, titleSize]
  );

  const titleWithDescriptionComponent = useMemo(() => {
    return (
      <div>
        <h4 className={s['description-subtitle']}>{subTitle}</h4>
        <div className={s.description}>{description}</div>
      </div>
    );
  }, [subTitle, description]);

  const buttonComponent = useMemo(() => {
    return (
      <div className={s.button_area}>
        <Button.Box state={button?.state} onClick={button?.onClick}>
          {buttonContent}
        </Button.Box>
      </div>
    );
  }, [button, buttonContent]);

  return (
    <article className={cn(s.guide, src || imgChild ? s['icon-space'] : s['basic-space'])}>
      {imgChild && <div className={s.icon_area}>{imgChild}</div>}
      {iconComponent && <div className={s.icon_area}>{iconComponent}</div>}
      {description ? titleWithDescriptionComponent : titleComponent}
      {buttonContent && buttonComponent}
    </article>
  );
};
const MemoGuideDescription = memo(GuideDescription);
export default MemoGuideDescription;
